import { PriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { AcceptedImportColumn } from '@retail/price-suggestion/types';

interface Props {
  t: PriceSuggestionTFunction;
  columnName: AcceptedImportColumn;
}

export const getColumnName = ({
  columnName,
  t,
}: Props) => {
  switch (columnName) {
    case 'mgItem':
      return  t('priceSuggestion.import.columns.mgItem');
    case 'supplierId':
      return t('priceSuggestion.import.columns.supplierId');
    case 'salesPrice':
      return t('priceSuggestion.import.columns.salesPrice');
    case 'validFrom':
      return  t('priceSuggestion.import.columns.fromDate');
   
    default:
      return '';
  }
};